import { render, staticRenderFns } from "./BaseModalCamera.vue?vue&type=template&id=da460b6e&scoped=true"
import script from "./BaseModalCamera.vue?vue&type=script&lang=js"
export * from "./BaseModalCamera.vue?vue&type=script&lang=js"
import style0 from "./BaseModalCamera.vue?vue&type=style&index=0&id=da460b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da460b6e",
  null
  
)

export default component.exports